import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWarning = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M9.05162 2.58537C8.58423 1.80488 7.41577 1.80488 6.94839 2.58537L1.1645 12.2439C0.697112 13.0244 1.28134 14 2.21611 14H13.7839C14.7187 14 15.3029 13.0244 14.8355 12.2439L9.05162 2.58537ZM7.6082 9.48535H8.41526L8.41526 6.60353C8.41526 6.38067 8.23459 6.2 8.01173 6.2C7.78886 6.2 7.6082 6.38067 7.6082 6.60353L7.6082 9.48535ZM7.36363 11.1043C7.36363 11.4396 7.63265 11.7125 8.00765 11.7125C8.3908 11.7125 8.66797 11.4396 8.66797 11.1043C8.66797 10.7691 8.3908 10.504 8.00765 10.504C7.63265 10.504 7.36363 10.7691 7.36363 11.1043Z",
		fill: "currentColor"
	})]
});
const ForwardRef = forwardRef(SvgWarning);
export default ForwardRef;
